import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "uk-tooltip"]
const _hoisted_2 = {
  key: 0,
  "uk-spinner": "ratio: 0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["shared-action-button uk-button uk-button-small", { 'main-button': _ctx.mainButton, 'danger-button': _ctx.dangerButton }]),
    type: "button",
    disabled: _ctx.isDisabled,
    "uk-tooltip": 
      !_ctx.allowed
        ? _ctx.$t('permissions.action_not_allowed')
        : _ctx.disabled && _ctx.disabledTooltip
        ? _ctx.disabledTooltip
        : undefined
    
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}